import * as React from 'react';
import { I18nextProvider } from 'react-i18next';
import { Toaster } from 'sonner';

import i18n from '@/i18n/config';
import { QueryProvider } from './query-provider';
import { ThemeProvider } from './theme-provider';
import { TooltipProvider } from '@/components/molecules/tooltip';

interface ProvidersProps {
  children: React.ReactNode;
}

export function Providers({ children }: ProvidersProps) {
  return (
    <I18nextProvider i18n={i18n}>
      <QueryProvider>
        <ThemeProvider>
          <TooltipProvider>
            {children}
            <Toaster
              position="top-right"
              richColors
              closeButton
            />
          </TooltipProvider>
        </ThemeProvider>
      </QueryProvider>
    </I18nextProvider>
  );
}
